'use client'

import { Button } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import TwoColumnsWithBackgroundImage from '@/components/TwoColumnsWithBackgroundImage'
import useDevice from '@/hooks/useDevice'

const WhyEmissionsIntelligenceMatters: FC = () => {
    const { mdScreen, smScreen } = useDevice()

    return (
        <TwoColumnsWithBackgroundImage
            mobileBackgroundImage={'/images/why-emissions-intelligence-matters-mobile.png'}
            backgroundImage={'/images/why-emissions-intelligence-matters-desktop.png'}
            leftSide={
                <Box
                    sx={{
                        gap: mdScreen ? 3 : 4,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        height: 'max-content',
                        maxWidth: smScreen ? 'auto' : '435px',
                    }}
                >
                    <Text sx={{ color: `White` }} variant={mdScreen ? 'h5' : 'h4'}>
                        Why emissions intelligence matters
                    </Text>
                    <Text sx={{ color: `White` }} variant={mdScreen ? 'body2' : 'body1'}>
                        We help logistics, spend management, and procurement platforms grow
                        customers by streamlining climate compliance and accelerating sustainability
                        goals for their clients.
                    </Text>
                    <Button
                        light={true}
                        sx={{ width: smScreen ? '100%' : 'auto' }}
                        variant={'contained'}
                        href={'/request-a-demo'}
                        leftIcon={<ArrowCircleRightIcon />}
                    >
                        Request a demo
                    </Button>
                </Box>
            }
            reversedOnMobile={true}
        />
    )
}

export default WhyEmissionsIntelligenceMatters
